import { GiveawayItem } from "../../lookups/models/giveaway-item.model";


export class GiveawayStock {
  id: number;
  quantity: number;
  giveawayItemId: number;
  giveawayItemName: string;
  giveawayItem: GiveawayItem;
}
